<ng-container *transloco="let t; prefix: scope">
  <div [class.nc-container]="!fullWidthHeader()" class="flex items-center gap-4 h-full">
    <rma-site-header-logo [renownedBranding]="renownedBranding()" />

    <rma-site-header-search
      [scope]="scope"
      class="opacity-100 transition-opacity"
      [class.!opacity-0]="basicHeader()"
      [class.pointer-events-none]="basicHeader()" />

    <div
      class="grow h-full flex items-center justify-end gap-2 opacity-100 transition-opacity"
      [class.!opacity-0]="basicHeader()"
      [class.pointer-events-none]="basicHeader()">
      @defer (when compareCount()) {
        <rma-site-header-compare-agent [scope]="scope" [compareCount]="compareCount()" />
      } @error {}

      @defer (when trackedCount()) {
        <rma-site-header-track-campaign [scope]="scope" [trackedCount]="trackedCount()" />
      } @error {}

      @if (showMarketingNav()) {
        <rma-site-header-navigation
          class="hidden md:block"
          [scope]="scope"
          displayMode="inline"
          [story]="story()"
          [reviews]="reviews()"
          [agents]="agents()"
          [group]="group()" />
      }

      <ng-container *rmaLet="isAuthenticated$ as isAuthenticated; suspenseRef: suspense">
        @if (!isAuthenticated) {
          <rma-site-header-login class="md:ml-4" [scope]="scope" />
        } @else {
          @defer (when isAuthenticated) {
            <rma-site-header-user class="md:ml-4" [scope]="scope" [userType]="userType()" />
          } @error {}
        }
      </ng-container>

      @if (showMarketingNav()) {
        <rma-site-header-navigation class="md:hidden" [scope]="scope" displayMode="menu" (toggleSideNav)="toggleSideNav()" />
      }

      <ng-template #suspense>
        <rma-icon glyph="sync" class="animate-spin" />
      </ng-template>
    </div>

    @if (loginHeader()) {
      <rma-site-header-logo [loginHeader]="true" />
    }

  </div>
</ng-container>
